export default __webpack_public_path__ + "static/media/cp_geo_hu.b4afa8ba.svg";